/* Shared, deterministic calculator helpers. Prices are verified by the app. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.CYPBespokeCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function dimension(raw) {
    if (raw == null || String(raw).trim() === '') return null;
    const value = Number(raw);
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }
  function sliderRange(value, initialMin = 200, initialMax = 2500) {
    if (!dimension(value)) return null;
    let min = dimension(initialMin) || 200;
    let max = dimension(initialMax) || 2500;
    if (max <= min) { min = 200; max = 2500; }
    if (value < min) min = 1;
    if (value > max) {
      const step = Math.pow(10, Math.max(2, Math.floor(Math.log10(value)) - 1));
      max = Math.min(Number.MAX_SAFE_INTEGER, Math.max(value, Math.ceil(value * 1.1 / step) * step));
    }
    return { min, max };
  }
  function properties(width, height) {
    if (!dimension(width) || !dimension(height)) return null;
    return {
      '_is_splashback': 'true',
      'Sizing type': 'Bespoke',
      'Width (mm)': String(width),
      'Height (mm)': String(height),
      'Production size': width + ' mm wide × ' + height + ' mm high'
    };
  }
  return Object.freeze({ dimension, sliderRange, properties });
});
